module.exports = __webpack_public_path__ + "static/forecast/weather/daylightrain-6745e4bece5b733196ad20b3214c5c35.svg";